import { render } from "./FlightConfirmationBanner.vue?vue&type=template&id=f2b65ed0"
import script from "./FlightConfirmationBanner.vue?vue&type=script&lang=js"
export * from "./FlightConfirmationBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__